import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/variables.css';
import './styles/base.css';
import './styles/layout.css';
import './styles/utilities.css';
import './styles/components.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

/**
 * Application entry point.
 *
 * BrowserRouter is used rather than HashRouter so future authentication
 * callbacks and deep links resolve on real paths. The host must rewrite
 * unknown paths to index.html -- on S3 + CloudFront this is a custom error
 * response on the distribution (see README.md, Deployment).
 *
 * Style sheets are imported in cascade order: design tokens, base element
 * styles, layout primitives, utilities, then component styles.
 */
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
